import { render, staticRenderFns } from "./add_item.vue?vue&type=template&id=1ff4c3ac&scoped=true"
import script from "./add_item.vue?vue&type=script&lang=js"
export * from "./add_item.vue?vue&type=script&lang=js"
import style0 from "./add_item.vue?vue&type=style&index=0&id=1ff4c3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4c3ac",
  null
  
)

export default component.exports